import { useState } from 'react';
// @ts-ignore
import styles from './FormTitle.module.scss';
import Text from '../Base/Text/Text';

interface FormTitleProps {
	tx: string;
	type?: 'default' | 'subtitle' | 'category';
}

export default function FormTitle(props: FormTitleProps) {
	const { tx, type } = props;

	switch (type) {
		case 'subtitle':
			return <Text tx={tx} firstUpper={true} className={styles.subtitle} />;
		case 'category':
			return <Text tx={tx} firstUpper={true} className={styles.category} />;
		case 'default':
		default:
			return <Text tx={tx} firstUpper={true} className={styles.title} />;
	}
}
